import { PropsWithChildren, useEffect, useMemo } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "../features/auth/AuthProvider";
import { SocketProvider } from "../features/socket/SocketProvider";
import { PushProvider } from "../features/push/PushProvider";
import { ToastHost, ConfirmHost, PromptHost } from "../components/common";
import { initMonitoring } from "../lib/monitoring";

const client = new QueryClient();

export function AppProviders({ children }: PropsWithChildren) {
  const queryClient = useMemo(() => client, []);
  useEffect(() => {
    initMonitoring();
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SocketProvider>
          <PushProvider>
            {children}
            <ToastHost />
            <ConfirmHost />
            <PromptHost />
          </PushProvider>
        </SocketProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
